<template>
	<div class="event-session-invitation-container">
		<!-- Loading State -->
		<div v-if="isLoading" class="loading-container">
			<div class="spinner-border text-primary" role="status">
				<span class="visually-hidden">Cargando...</span>
			</div>
			<p class="mt-3">Validando invitación...</p>
		</div>

		<!-- Invalid Invitation -->
		<div v-else-if="!isValidInvitation" class="invalid-invitation">
			<div class="card text-center p-4">
				<div class="d-flex gap-2 align-items-center justify-content-center mb-3">
					<i class="fas fa-exclamation-circle text-danger fa-2x"></i>
					<span class="h2 m-0">Invitación no válida</span>
				</div>

				<p>{{ validationReason }}</p>

				<a :href="weWelcomUrl" class="btn btn-primary mt-3"> Volver al inicio </a>
			</div>
		</div>

		<!-- Valid Invitation - Registration Form -->
		<div v-else class="registration-container">
			<!-- Header -->
			<header class="event-header">
				<div class="event-header-content-img">
					<img class="event-header-img" src="../../../public/img/LOGO_MACARFI_ALTA_2.jpg" alt=""/>
				</div>
				<div
					class="event-header-content"
					style="background-image: linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.667)), url('/img/header.jpg');background-repeat: no-repeat;background-size: cover;background-position: center;">
					<div v-if="false" class="venue-info">
						<h4 class="venue-name">{{ venue?.name }}</h4>
					</div>
					<h1 class="event-title">{{ event?.name }}</h1>
					<p v-if="event?.description" class="event-description">{{ event.description }}</p>
					<div class="d-flex justify-content-center align-items-center w-100 content-sponsor" style="background: white;border-radius: 10px;">
						<img class="event-header-img sponsor" src="../../../public/img/LogoANDBANK.jpg" alt=""/>
					</div>
				</div>
			</header>

			<!-- Session Info Card -->
			<div class="session-card">
				<div class="session-info">
					<div class="session-detail">
						<i class="fas fa-calendar-alt"></i>
						<span>{{ formattedSessionDate }}</span>
					</div>
					<div class="session-detail">
						<i class="fas fa-clock"></i>
						<span>{{ formattedSessionTime }}</span>
					</div>
					<div class="session-detail">
						<i class="fa-solid fa-location-dot"></i>
						<span>Círculo de Bellas Artes</span>
					</div>
					<div v-if="false" class="session-detail">
						<i class="fas fa-ticket-alt"></i>
						<span>{{ invitation?.name }}</span>
					</div>
				</div>
			</div>

			<!-- Registration Success Message -->
			<div v-if="registrationResult" class="success-container">
				<div class="card text-center p-4">
					<div class="d-flex gap-2 align-items-center justify-content-center mb-3">
						<i class="fas fa-check-circle text-success fa-2x"></i>
						<span class="h2 m-0">¡Registro completado!</span>
					</div>
					<p class="text-muted">Tu registro para el evento ha sido confirmado.</p>
					<p v-if="registrationResult.isNewUser" class="small text-muted">Hemos creado una cuenta para ti con el email proporcionado.</p>
					<a :href="registrationResult.redirectUrl" class="btn btn-primary mt-3">
						<i class="fas fa-qrcode me-2"></i>
						<span v-if="countdown !== null">
							Te llevaremos a tu pase en {{ countdown }}...
						</span>
						<span v-else>
							Ver mi pase
						</span>
					</a>
				</div>
			</div>

			<!-- Registration Form -->
			<form v-else @submit.prevent="handleSubmit" class="card">
				<div class="card-body text-start">
					<!-- User Data Section -->
					<div class="form-section">
						<h3 class="section-title">Tus datos</h3>
						<div class="row g-3">
							<div class="col-md-6">
								<div class="mb-3">
									<InputText id="name" v-model="formData.name" placeholder="Tu nombre" :hasError="nameValidation.attempted && !nameValidation.valid">
										<i class="fa-solid fa-user-pen"></i>
										<template #label> Nombre*</template>
									</InputText>
									<div v-if="nameValidation.attempted && !nameValidation.valid" class="invalid-feedback d-block">Por favor, introduce tu nombre</div>
									<!--									<label for="name" class="form-label">Nombre *</label>
																		<input
																			type="text"
																			class="form-control"
																			id="name"
																			v-model="formData.name"
																			required
																			placeholder="Tu nombre"
																		>-->
								</div>
							</div>
							<div class="col-md-6">
								<div class="mb-3">
									<!--									<label for="surname" class="form-label">Apellidos</label>
																		<input
																			type="text"
																			class="form-control"
																			id="surname"
																			v-model="formData.surname"
																			placeholder="Tus apellidos"
																		>-->
									<InputText id="surname" v-model="formData.surname" placeholder="Tus apellidos" :hasError="surnameValidation.attempted && !surnameValidation.valid">
										<template #label> Apellidos*</template>
									</InputText>
									<div v-if="surnameValidation.attempted && !surnameValidation.valid" class="invalid-feedback d-block">Por favor, introduce tus apellidos</div>
								</div>
							</div>
							<div class="col-md-6">
								<div class="mb-3">
									<!--									<label for="email" class="form-label">Email *</label>
																		<input
																			type="email"
																			class="form-control"
																			id="email"
																			v-model="formData.email"
																			required
																			placeholder="tu@email.com"
																		>-->

									<InputText id="email" v-model="formData.email" placeholder="tu@email.com" :hasError="emailValidation.attempted && !emailValidation.valid">
										<template #label> Email*</template>
									</InputText>
									<div v-if="emailValidation.attempted && !emailValidation.valid" class="invalid-feedback d-block">Por favor, introduce un email válido</div>
								</div>
							</div>
							<div class="col-md-6">
								<div class="mb-3">
									<label for="phone" class="form-label">Teléfono</label>
									<vue-tel-input v-model="phoneInputValue" @validate="onPhoneValidate" :inputOptions="phoneInputOptions" :dropdownOptions="phoneDropdownOptions" :preferredCountries="preferredCountries" defaultCountry="es" mode="international" class="phone-input" :class="{ 'is-invalid': phoneValidation.attempted && !phoneValidation.valid }"/>
									<!-- <div v-if="phoneValidation.attempted && !phoneValidation.valid"
										class="invalid-feedback d-block">
										Por favor, introduce un número de teléfono válido
									</div> -->
								</div>
							</div>
						</div>
					</div>

					<!-- Companions Section (if allowed) -->
					<div v-if="maxCompanions > 0" class="form-section">
						<h3 class="section-title">Acompañantes</h3>
						<p class="text-muted small">Puedes traer hasta {{ maxCompanions }} acompañante(s)</p>

						<div class="mb-3">
							<label for="companions" class="form-label">Número de acompañantes</label>
							<select class="form-select" id="companions" v-model="formData.companions">
								<option v-for="n in maxCompanions + 1" :key="n - 1" :value="n - 1">
									{{ n - 1 }}
								</option>
							</select>
						</div>
					</div>

					<!-- Custom Form Fields Section -->
					<div v-if="formFields.length > 0" class="form-section">
						<h3 class="section-title">Información adicional</h3>

						<div v-for="field in formFields" :key="field.id" class="mb-3">
							<label :for="field.name" class="form-label">
								{{ field.label }}
								<span v-if="field.required" class="text-danger">*</span>
							</label>

							<!-- Text input -->
							<input v-if="field.type === 'text' || field.type === 'email' || field.type === 'phone'" :type="field.type === 'email' ? 'email' : field.type === 'phone' ? 'tel' : 'text'" class="form-control" :id="field.name" v-model="customFormData[field.name]" :required="field.required" :placeholder="field.config?.placeholder || ''"/>

							<!-- Textarea -->
							<textarea v-else-if="field.type === 'textarea'" class="form-control" :id="field.name" v-model="customFormData[field.name]" :required="field.required" :placeholder="field.config?.placeholder || ''" rows="3"></textarea>

							<!-- Number input -->
							<input v-else-if="field.type === 'int'" type="number" class="form-control" :id="field.name" v-model.number="customFormData[field.name]" :required="field.required" :min="field.config?.min" :max="field.config?.max" :step="field.config?.step || 1"/>

							<!-- Select -->
							<select v-else-if="field.type === 'select'" class="form-select" :id="field.name" v-model="customFormData[field.name]" :required="field.required">
								<option value="">Selecciona una opción</option>
								<option v-for="option in field.config?.options || []" :key="option.value" :value="option.value">
									{{ option.label }}
								</option>
							</select>

							<!-- Checkbox (bool) -->
							<div v-else-if="field.type === 'bool'" class="form-check">
								<input type="checkbox" class="form-check-input" :id="field.name" v-model="customFormData[field.name]"/>
								<label class="form-check-label" :for="field.name">
									{{ field.label }}
								</label>
							</div>

							<!-- Date -->
							<input v-else-if="field.type === 'date'" type="date" class="form-control" :id="field.name" v-model="customFormData[field.name]" :required="field.required"/>
						</div>
					</div>
					<div class="form-section">
						<div class="form-check">
							<input v-model="acceptedTerms" id="accept-terms" class="form-check-input" type="checkbox" :class="{ 'is-invalid': termsValidation.attempted && !acceptedTerms }"/>
							<label class="form-check-label" for="accept-terms"> Acepto la política de privacidad </label>
							<a data-bs-toggle="modal" data-bs-target="#privacy-terms-modal" class="f-no-utm terms link" href="#termsPrivacy">(ver)</a>
						</div>
						<div v-if="termsValidation.attempted && !acceptedTerms" class="invalid-feedback d-block">Por favor, acepta los términos y condiciones para continuar</div>
					</div>

					<!-- Error Message (above submit button) -->
					<div v-if="registrationError" class="alert alert-danger mb-3" ref="errorAlertRef">
						<i class="fas fa-exclamation-triangle me-2"></i>
						{{ registrationError }}
					</div>

					<!-- Submit Button -->
					<div class="form-actions">
						<PrimaryButton type="submit" class="w-100" :is-disabled="isSubmitting">
							<!--								<button
																type="submit"
																class="btn btn-primary btn-lg w-100"
																:disabled="isSubmitting"
															>-->
							<span v-if="isSubmitting">
								<span class="spinner-border spinner-border-sm me-2" role="status"></span>
								Registrando...
							</span>
							<span v-else>
								<i class="fas fa-check-circle me-2"></i>
								Registrarme
							</span>
						</PrimaryButton>
					</div>
				</div>
			</form>
		</div>

		<!-- Footer -->
		<footer class="event-footer">
			<a href="wewelcom.io">
				<img :src="`https://api.wewelcom.io/world/img/wewelcom/logo/logo.png`" alt="WeWelcom" class="wewelcom-logo"/>
			</a>

			<span class="powered-by-text">Wewelcom es Tecnología más humana para restauración</span>
		</footer>
	</div>
</template>

<script setup>
import {ref, reactive, computed, watch, nextTick, onUnmounted} from "vue";
import {useRoute} from "vue-router";
import {useStore} from "vuex";
import {storeToRefs} from "pinia";
import {useEventSessionInvitationStore} from "@/store/eventSessionInvitationStore";
import {VueTelInput} from "vue3-tel-input";
import "vue3-tel-input/dist/vue3-tel-input.css";
import parsePhoneNumberFromString from "libphonenumber-js";
import InputText from "@/components/ui/inputs/inputsVariant/InputText.vue";
import PrimaryButton from "@/components/ui/buttons/variants/PrimaryButton.vue";
import {cookieManager} from "@/service/cookieManager";

// Vuex store (for config only)
const vuexStore = useStore();
const weWelcomUrl = computed(() => vuexStore.getters["config/weWelcomUrl"]);

// Countdown for redirect
const countdown = ref(null);
let countdownInterval = null;

onUnmounted(() => {
	if (countdownInterval) {
		clearInterval(countdownInterval);
	}
});

function startRedirectCountdown(redirectUrl) {
	countdown.value = 3;
	countdownInterval = setInterval(() => {
		countdown.value--;
		if (countdown.value <= 0) {
			clearInterval(countdownInterval);
			window.location.href = redirectUrl;
		}
	}, 1000);
}

// Pinia store
const eventSessionInvitationStore = useEventSessionInvitationStore();
const {
	isLoading,
	isValidInvitation,
	validationReason,
	invitation,
	event,
	venue,
	formFields,
	maxCompanions,
	isSubmitting,
	registrationResult,
	registrationError,
	formattedSessionDate,
	formattedSessionTime
} = storeToRefs(eventSessionInvitationStore);

// Route
const route = useRoute();
const invitationToken = computed(() => route?.query?.token || new URLSearchParams(window.location.search).get("token"));

// Form data
const formData = reactive({
	name: "",
	surname: "",
	email: "",
	phone: "",
	phoneE164: "",
	companions: 0,
});
const customFormData = ref({});

// Template refs
const errorAlertRef = ref(null);

// Phone input configuration
const phoneInputValue = ref("");
const phoneValidation = reactive({
	valid: false,
	attempted: false,
});

const phoneInputOptions = {
	id: "phone",
	placeholder: "Introduce tu teléfono",
	required: false,
	autocomplete: "tel",
	name: "phone",
	type: "tel",
};

const phoneDropdownOptions = {
	showDialCodeInSelection: true,
	showFlags: true,
	showSearchBox: true,
	searchBoxPlaceholder: "Buscar país...",
};

// Preferred countries shown at top of the dropdown
const preferredCountries = ["es", "fr", "pt", "it", "de", "gb"];

// Phone validation handler
function onPhoneValidate(validation) {
	phoneValidation.valid = validation.valid;
	phoneValidation.attempted = true;

	if (validation.valid && validation.formatted) {
		// Store both formatted and E.164 versions
		formData.phone = validation.formatted;

		// Parse to get E.164 format
		try {
			const parsedNumber = parsePhoneNumberFromString(validation.formatted, validation.countryCode);
			if (parsedNumber) {
				formData.phoneE164 = parsedNumber.number; // E.164 format
			}
		} catch (e) {
			console.warn("Could not parse phone number:", e);
			formData.phoneE164 = validation.formatted;
		}
	} else {
		formData.phone = "";
		formData.phoneE164 = "";
	}
}

// Email validation
const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
const emailValidation = reactive({
	valid: true,
	attempted: false,
});

watch(
	() => formData.email,
	(newValue) => {
		if (emailValidation.attempted) {
			emailValidation.valid = emailRegex.test(newValue);
		}
	}
);

const acceptedTerms = ref(false);
const termsValidation = reactive({
	attempted: false,
});

watch(acceptedTerms, (newValue) => {
	if (termsValidation.attempted && newValue) {
		termsValidation.attempted = false;
	}
});

const nameValidation = reactive({
	valid: true,
	attempted: false,
});
const surnameValidation = reactive({
	valid: true,
	attempted: false,
});

watch(
	() => [formData.name, formData.surname],
	([newName, newSurname]) => {
		if (nameValidation.attempted) nameValidation.valid = !!newName;
		if (surnameValidation.attempted) surnameValidation.valid = !!newSurname;
	},
	{immediate: true}
);

// Initialize custom form data when fields are loaded
watch(
	formFields,
	(fields) => {
		if (fields && fields.length > 0) {
			fields.forEach((field) => {
				if (!(field.name in customFormData.value)) {
					// Set default values based on field type
					if (field.type === "bool") {
						customFormData.value[field.name] = false;
					} else if (field.type === "int") {
						customFormData.value[field.name] = field.config?.min || 0;
					} else {
						customFormData.value[field.name] = "";
					}
				}
			});
		}
	},
	{immediate: true}
);

// Methods
async function handleSubmit() {
	let isValid = true;
	let firstErrorElement = null;

	// Mark phone as attempted if user tries to submit
	if (phoneInputValue.value) {
		phoneValidation.attempted = true;
	}

	// Validate email
	emailValidation.attempted = true;
	emailValidation.valid = emailRegex.test(formData.email);
	if (!emailValidation.valid) {
		isValid = false;
		if (!firstErrorElement) firstErrorElement = "email";
	}

	// Validate name
	nameValidation.attempted = true;
	nameValidation.valid = !!formData.name;
	if (!nameValidation.valid) {
		isValid = false;
		if (!firstErrorElement) firstErrorElement = "name";
	}

	surnameValidation.attempted = true;
	surnameValidation.valid = !!formData.surname;
	if (!surnameValidation.valid) {
		isValid = false;
		if (!firstErrorElement) firstErrorElement = "surname";
	}

	termsValidation.attempted = true;

	// Check terms acceptance
	if (!acceptedTerms.value) {
		isValid = false;
		if (!firstErrorElement) firstErrorElement = "accept-terms";
	}

	if (!isValid) {
		await nextTick();
		if (firstErrorElement) {
			const element = document.getElementById(firstErrorElement);
			if (element) {
				element.scrollIntoView({behavior: "smooth", block: "center"});
			}
		}
		return;
	}

	const result = await eventSessionInvitationStore.submitRegistration({
		token: invitationToken.value,
		userData: {
			name: formData.name,
			surname: formData.surname,
			email: formData.email,
			phone: formData.phoneE164 || formData.phone, // Prefer E.164 format
			userAcceptedTerms: acceptedTerms.value,
		},
		formData: customFormData.value,
		companions: formData.companions,
	});

	if (result.success) {
		// Save token immediately for persistent login
		if (result.token) {
			cookieManager.setToken(result.token);
		}
		// Scroll to top to show success message
		window.scrollTo({top: 0, behavior: "smooth"});
		// Start countdown to redirect to WePass
		if (result.redirectUrl) {
			startRedirectCountdown(result.redirectUrl);
		}
	} else {
		// Scroll to error alert after Vue updates the DOM
		await nextTick();
		if (errorAlertRef.value) {
			errorAlertRef.value.scrollIntoView({behavior: "smooth", block: "center"});
		}
	}
}

/*const headerImageUrl = computed(() => {
	if (!venue.value?.resource_id) return "";
	return `${weWelcomUrl.value}/world/img/${venue.value.resource_id}/logo/logo.png`;
});*/
</script>

<style scoped>
.event-session-invitation-container {
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	min-height: 100vh;
	background: radial-gradient(circle, #2c5364, #203a43, #0f2027);
	padding: 20px;
}

.loading-container {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	min-height: 80vh;
	color: white;
}

.invalid-invitation {
	display: flex;
	align-items: center;
	justify-content: center;
	min-height: 80vh;
}

.invalid-invitation .card {
	max-width: 400px;
	border-radius: 16px;
	box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
}

.registration-container {
	max-width: 800px;
	margin: 0 auto;
}

.event-header {
	display: flex;
	gap: 1rem;

	text-align: center;
	color: white;
	padding: 20px 0 30px;
}

.event-header-content-img {
	max-width: 190px;
}

.event-header-img {
	max-width: 100%;
	max-height: 100%;
	height: auto;
	width: auto;
	border-radius: 15px;
}

.sponsor {
	max-height: 40px;
	//max-width: 100px;
	border-radius: 10px;
	object-fit: cover;
}

.event-header-content {
	//margin-inline: auto;
	display: grid;
	place-content: center;
	width: 100%;
	border-radius: 15px;
	padding: 8px;
}

.venue-name {
	font-size: 1rem;
	opacity: 0.9;
	margin-bottom: 10px;
}

.event-title {
	font-size: 2rem;
	font-weight: 700;
	margin-bottom: 10px;
}

.event-description {
	opacity: 0.9;
	font-size: 1rem;
	margin-bottom: 0;
}

.session-card {
	background: rgba(255, 255, 255, 0.15);
	backdrop-filter: blur(10px);
	border-radius: 16px;
	padding: 20px;
	margin-bottom: 20px;
	color: white;
}

.session-info {
	display: flex;
	flex-wrap: wrap;
	gap: 15px;
	justify-content: center;
}

.session-detail {
	display: flex;
	align-items: center;
	gap: 8px;
	font-size: 0.95rem;
}

.session-detail i {
	opacity: 0.8;
}

.success-container {
	animation: fadeIn 0.5s ease;
}

.success-container .card {
	border-radius: 16px;
	box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
}

.registration-form {
	background: white;
	border-radius: 16px;
	padding: 30px;
	box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
}

.form-section {
	margin-bottom: 20px;
}

.section-title {
	font-size: 1.2rem;
	font-weight: 600;
	margin-bottom: 20px;
	padding-bottom: 10px;
	border-bottom: 2px solid var(--app-accent);
	color: #333;
}

.form-check-label {
	font-size: 0.95rem;
	color: #555;
	cursor: pointer;
}

.form-check-input {
	cursor: pointer;
	margin-top: 0.25rem;
}

.form-check-input:checked {
	background-color: var(--app-accent, #2c5364);
	border-color: var(--app-accent, #2c5364);
}

.invalid-feedback {
	font-size: 0.875rem;
	color: #dc3545;
	margin-top: 0.25rem;
}

/*.form-label {
	font-weight: 500;
	color: #555;
}*/

/*
.form-control,
.form-select {
	border-radius: 10px;
	padding: 12px 15px;
	border: 1px solid #e0e0e0;
	transition: border-color 0.2s, box-shadow 0.2s;
}*/
/*
.form-control:focus,
.form-select:focus {
	border-color: #2C5364;
	box-shadow: 0 0 0 3px rgba(44, 83, 100, 0.2);
}*/

/*
!* Phone Input Styles *!
.phone-input {
	border-radius: 10px;
	border: 1px solid #e0e0e0;
	background: white;
	transition: border-color 0.2s, box-shadow 0.2s;
}

.phone-input:focus-within {
	border-color: #2C5364;
	box-shadow: 0 0 0 3px rgba(44, 83, 100, 0.2);
}

.phone-input.is-invalid {
	border-color: #dc3545;
}

.phone-input.is-invalid:focus-within {
	box-shadow: 0 0 0 3px rgba(220, 53, 69, 0.2);
}
*/

/* Override vue-tel-input default styles */
/*:deep(.vue-tel-input) {
	border: none !important;
	border-radius: 10px;
}

:deep(.vti__input) {
	border: none !important;
	border-radius: 0 10px 10px 0;
	padding: 12px 15px;
	font-size: 1rem;
}

:deep(.vti__dropdown) {
	border: none !important;
	border-right: 1px solid #e0e0e0 !important;
	border-radius: 10px 0 0 10px;
	background-color: #f8f9fa;
}

:deep(.vti__dropdown:hover) {
	background-color: #e9ecef;
}

:deep(.vti__dropdown-list) {
	border: 1px solid #e0e0e0;
	border-radius: 8px;
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
	max-height: 250px;
}

:deep(.vti__dropdown-item) {
	padding: 10px 12px;
}

:deep(.vti__dropdown-item.highlighted) {
	background-color: #2C5364;
	color: white;
}

:deep(.vti__search_box) {
	border: 1px solid #e0e0e0;
	border-radius: 6px;
	margin: 8px;
	padding: 8px 12px;
}*/

.form-actions {
	margin-top: 30px;
}

.event-footer {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 8px;
	padding: 12px 0;
	margin-top: 20px;
	background: transparent;
	color: rgba(255, 255, 255, 0.8);
	box-shadow: none;
	text-align: center;
}

.powered-by-text {
	font-size: 1.2rem;
}

.wewelcom-logo {
	height: 55px;
}

@keyframes fadeIn {
	from {
		opacity: 0;
		transform: translateY(20px);
	}

	to {
		opacity: 1;
		transform: translateY(0);
	}
}

/* Mobile responsive adjustments */
@media (max-width: 576px) {
	.event-session-invitation-container {
		padding: 15px;
	}

	.event-title {
		font-size: 1.5rem;
	}

	.registration-form {
		padding: 20px;
	}

	.session-info {
		flex-direction: column;
		align-items: center;
	}

	.sponsor {
		max-height: 30px;
	}

	.content-sponsor {
		max-width: calc(100% - 10px);
		margin: 0 auto;
	}

	.event-header-content-img {
		max-width: 130px;
	}
}
</style>
